
import axios from "axios";
import moment from 'moment'
import Tools from '@/tools/tools.js'
import { LIMITE_REGISTROS_PESQUISA } from '../../../static/parametros/parametros.js'

export default {
  namespaced: true,
  state: {
      lista: [],
      dt1: Tools.formatarDataParaInput(Tools.getDataAtual()),
      dt2: Tools.formatarDataParaInput(Tools.getDataAtual()),
      id: null,
      documento: null,
      clienteId: null,
      ignorarData: false,
      transportadoraId: null,
      tipoDoc: '',
      tipoData: '0',
      perPage: 100,
      registroSelecionadoId: null,
      paginaAtual: 1,
  },
  getters: {
    LISTA: state => {
        return state.lista
    },
    PER_PAGE: state => { 
        return state.perPage
    },
    DT1: state => {
        return state.dt1
    },
    DT2: state => {
        return state.dt2
    },
    ID: state => {
        return state.id
    },
    IGNORAR_DATA: state => {
        return state.ignorarData
    },
    CLIENTE_ID: state => {
        return state.clienteId
    },
    TRANSPORTADORA_ID: state => {
        return state.transportadoraId
    },
    DOCUMENTO: state => {
        return state.documento
    },
    TIPO_DOC: state => {
        return state.tipoDoc
    },
    TIPO_DATA: state => {
        return state.tipoData
    },
    REGISTRO_SELECIONADO_ID: state => {
        return state.registroSelecionadoId
    },
    PAGINA_ATUAL: state => {
        return state.paginaAtual
    }
  },
  /** MUTACOES SAO SINCRONAS - SEMELHANTES AO COMPUTED */
  mutations: {
      SET_LISTA: (state, payload) => {
          state.lista = payload
      },
      SET_PER_PAGE: (state, payload) => {
          state.perPage = payload
      },
      SET_DT1: (state, payload) => {
          state.dt1 = payload
      },
      SET_DT2: (state, payload) => {
          state.dt2 = payload
      },
      SET_ID: (state, payload) => {
          state.id = payload
      },
      SET_IGNORAR_DATA: (state, payload) => {
          state.ignorarData = payload
      },
      SET_CLIENTE_ID: (state, payload) => {
          state.clienteId = payload
      },
      SET_TRANSPORTADORA_ID: (state, payload) => {
          state.transportadoraId = payload
      },
      SET_DOCUMENTO: (state, payload) => {
          state.documento = payload
      },
      SET_TIPO_DOC: (state, payload) => {
          state.tipoDoc = payload
      },
      SET_TIPO_DATA: (state, payload) => {
          state.tipoData = payload
      },
      SET_REGISTRO_SELECIONADO_ID: (state, payload) => {
          state.registroSelecionadoId = payload
      },
      SET_PAGINA_ATUAL: (state, payload) => {
          state.paginaAtual = payload
      },
      SET_LIMPAR: (state, payload) => {
        state.lista = []
        state.dt1 = Tools.formatarDataParaInput(Tools.getDataAtual()),
        state.dt2 = Tools.formatarDataParaInput(Tools.getDataAtual()),
        state.id = null
        state.documento = null
        state.clienteId = null
        state.ignorarData = false
        state.transportadoraId = null
        state.tipoDoc = ''
        state.tipoData = '0'
      }
  },
  /** ACTOINS SAO ASSINCRONOS */
  actions: {
    GERAR_LISTA: ({ commit, getters}, { skipConfirmation = false } = {}) => {
        return new Promise((resolve, reject) => {
          let id = getters.ID ?? ''
          let clienteId = getters.CLIENTE_ID ?? ''
          let documento = getters.DOCUMENTO ?? ''
          let tipoDoc = getters.TIPO_DOC ?? ''
          let tipoData = getters.TIPO_DATA ?? ''
          let ignorarData = getters.IGNORAR_DATA ?? ''
          let dt1 = getters.DT1 ?? ''
          let dt2 = getters.DT2 ?? ''
          let transportadoraId = getters.TRANSPORTADORA_ID ?? ''

          let uri = `/api/protected/gestaoCompra/pesquisar?dt1=${dt1}&dt2=${dt2}`
          if (id) {uri += `&id=${id}`}
          if (ignorarData == true) {uri += `&ignorarData=1`}
          if (documento) { uri += `&documento=${documento}` }
          if (tipoDoc) { uri += `&tipoDoc=${tipoDoc}` } 
          if (tipoData) { uri += `&tipoData=${tipoData}` } 
          if (clienteId) { uri += `&clienteId=${clienteId}` }
          if (transportadoraId) { uri += `&transportadoraId=${transportadoraId}`  }
          
          axios
            .get(uri)
            .then(({ data, status }) => {
              // Verifica se o resultado tem mais de LIMITE_REGISTROS_PESQUISA registros e precisa de confirmação
              if (!skipConfirmation && data && data.length > LIMITE_REGISTROS_PESQUISA) {
                // Retorna os dados sem comitar, indicando que precisa de confirmação
                resolve({ 
                  data, 
                  status,
                  needsConfirmation: true,
                  count: data.length
                });
                return
              }
              
              commit("SET_LISTA", data);
              if (status === 200 || status === 201) {
                return resolve({ data, status, needsConfirmation: false });
              }
            })
            .catch(err => {
              console.log(err)
              return reject(err)
            })
        })
      }
  }
}


// WEBPACK FOOTER //
// ./src/vuex/modulos/compra-store.js